<template>
  <div class="member-invite-enter-details">
    <img class="header-image" :src="require('@/assets/invite-member-top.svg')">
    <div class="content">
      <div class="title">הוזמנת למנוי משותף עם {{ primaryMemberDetails.firstName }}, ביחד קל יותר לנצח את החודש!</div>
      <div class="ask-details">ליצירת חשבון ה-riseup האישי שלך, נצטרך כמה פרטים ונשלח לך קוד אימות ב-WhatsApp.</div>
      <enter-details :action="generateCodeAndProceed"
                        :error="errors.generateCode"
                        :reset-error="() => resetError('generateCode')"/>

      <div class="privacy-message">לעולם לא נמסור את הפרטים שלך לאף צד שלישי.</div>
      <support-footer/>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../../Segment';
import EnterDetails from '../../../../../base-components/EnterDetails.vue';

export default {
  name: 'MemberInviteEnterDetails',
  components: {
    EnterDetails,
    SupportFooter: BaseUI.SupportFooter,
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('MemberInviteEnterDetailsEntered');
  },
  computed: {
    ...mapState('memberInvite', ['errors']),
    ...mapState('inviteSession', ['primaryMemberDetails']),
  },
  methods: {
    ...mapMutations('memberInvite', ['setFirstName', 'setLastName', 'setPhoneNumber', 'resetError', 'setEmail', 'setEnableMarketingEmails']),
    ...mapActions('memberInvite', ['generateCode']),
    async generateCodeAndProceed(firstName, lastName, phoneNumber, email, enableMarketingEmails) {
      await this.setFirstName(firstName);
      await this.setLastName(lastName);
      await this.setPhoneNumber(phoneNumber);
      await this.setEmail(email);
      await this.setEnableMarketingEmails(enableMarketingEmails);
      await this.generateCode();
      this.next();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .member-invite-enter-details {
    display: flex;
    flex-direction: column;
    font-family: SimplerPro;

    .header-image {
      width: 100%;
    }

    .content {
      margin: 30px;

      .title {
        font-size: 22px;
        line-height: 28px;
        font-weight: bold;
        margin-bottom: 15px;
      }

      .ask-details {
        margin-bottom: 27px;
        font-size: 18px;
        line-height: 27px;
      }

      .privacy-message {
        margin: 24px 0 18px 0;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
      }

      .support-footer {
        text-align: center;
      }
    }
  }
</style>
